var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19H5.75C2.1 19 0 16.9 0 13.25V6.25C0 2.6 2.1 0.5 5.75 0.5H12.75C13.16 0.5 13.5 0.84 13.5 1.25C13.5 1.66 13.16 2 12.75 2H5.75C2.89 2 1.5 3.39 1.5 6.25V13.25C1.5 16.11 2.89 17.5 5.75 17.5H15.75C18.61 17.5 20 16.11 20 13.25V8.25C20 7.84 20.34 7.5 20.75 7.5C21.16 7.5 21.5 7.84 21.5 8.25V13.25C21.5 16.9 19.4 19 15.75 19Z",
    fill: "#00FFA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7488 10.62C9.9088 10.62 9.0588 10.36 8.4088 9.83002L5.2788 7.33002C4.9588 7.07002 4.89881 6.60002 5.1588 6.28002C5.41881 5.96002 5.88879 5.90003 6.20879 6.16003L9.3388 8.66003C10.0988 9.27003 11.3888 9.27003 12.1488 8.66003L13.3288 7.72002C13.6488 7.46002 14.1288 7.51002 14.3788 7.84002C14.6388 8.16002 14.5888 8.64002 14.2588 8.89002L13.0788 9.83002C12.4388 10.36 11.5888 10.62 10.7488 10.62Z",
    fill: "#00FFA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 6.5C16.46 6.5 15 5.04 15 3.25C15 1.46 16.46 0 18.25 0C20.04 0 21.5 1.46 21.5 3.25C21.5 5.04 20.04 6.5 18.25 6.5ZM18.25 1.5C17.29 1.5 16.5 2.29 16.5 3.25C16.5 4.21 17.29 5 18.25 5C19.21 5 20 4.21 20 3.25C20 2.29 19.21 1.5 18.25 1.5Z",
    fill: "#00FFA3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms-notification.7d6c2bbafbf234a8ed3e3368c3d02aac.svg";
export { ForwardRef as ReactComponent };